// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p4-1";
export var messageSideRight = "_p4-2";
export var orderLookupBubbleContainer = "_p4-0";
export var submitButton = "_p4-3";